var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.39 5.491a.625.625 0 00-.884-.883L9.997 9.116 5.49 4.608a.625.625 0 00-.883.883l4.508 4.508-4.508 4.509a.625.625 0 10.883.883l4.508-4.508 4.509 4.508a.625.625 0 00.883-.883l-4.508-4.509 4.508-4.508z",
    fill: "#fff"
  })));
}
export default SvgCloseIcon;